<template>
  <a-modal
    title="商品库列表"
    :width="700"
    :visible="visible"
    @cancel="handleCancel"
    :footer="false"
  >
  <a-spin :spinning="loading">
    <div class="goods-container">
      <a-list itemLayout="horizontal" :dataSource="list" :split="false">
        <a-list-item slot="renderItem" slot-scope="item" @click="handleSelect(item)">
          <goods-card class="goods-card" :goodsinfo="item">
            <template v-slot:fd>
              <div class="goods-select-btn">选择</div>
            </template>
          </goods-card>
        </a-list-item>
      </a-list>
    </div>
  </a-spin>
  </a-modal>
</template>

<script>
import ActivityApi from '@/api/activity'
import GoodsCard from '@/views/activity/components/GoodsCard'
export default {
  components: {
    GoodsCard
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      list: [],
      loading: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    show() {
      this.getData()
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    getData() {
      this.loading = true
      ActivityApi.getGoodsList({ pageSize: 100 }).then(res => {
        this.list = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    handleSelect(item) {
      this.$emit('ok',item)
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.goods-container {
  display: flex;
  flex-direction: column;
  .goods-card {
    .goods-select-btn {
      line-height: 64px;
      width: 50px;
      color: #1890ff;
      display: none;
    }
  }
  .goods-card:hover {
    .goods-select-btn {
      display: flex;
    }
  }
}
</style>
